<ng-container *ngLet="globalSearch$ | async">
  <div class="search-container" #searchContainer cdkOverlayOrigin #searchTrigger="cdkOverlayOrigin">
    <input
      *ngLet="searchDebouncer$ | async"
      [formControl]="searchInputControl"
      type="text"
      (click)="isOpenSelect = true"
      class="search-input body1-impaired"
      placeholder="{{ 'VERSION_VISUALLY_IMPAIRED.SEARCH_PLACEHOLDER' | translate }}"
    />
    <div class="impaired-size-58 icon-container">
      <app-impaired-icon [iconName]="icons.Search" [classSize]="'big-impaired'"></app-impaired-icon>
    </div>
  </div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayPositions]="overlayPosition"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayOrigin]="searchTrigger"
  [cdkConnectedOverlayOpen]="isOpenSelect"
  (backdropClick)="isOpenSelect = !isOpenSelect"
  [cdkConnectedOverlayPanelClass]="'cdk-version-for-visually-impaired'"
>
  <ul  *ngIf="searchResults.length > 0" class="option-list" [style.width]="(searchContainer.offsetWidth - 4) | px">
    <div *ngFor="let row of searchResults" class="option-item body1-impaired" (click)="onChooseSearchRow(row)">{{ row.name }}</div>
  </ul>
</ng-template>

</ng-container>
